import { Headphones, Mail, Calendar, Image } from "lucide-react";

export default function FeatureSection() {
    return (
        <section className="relative w-full py-20 lg:py-24 bg-[#1a1a1a]">
            <div className="container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    
                    {/* Left side - Heading */}
                    <div className="lg:col-span-3">
                        <h2 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                            All plans include
                        </h2>
                    </div>

                    {/* Right side - Features grid */}
                    <div className="lg:col-span-9">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-6">

                            {/* Feature 1 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Headphones className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Round-the-clock assistance
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Get instant help whenever you need it with our dedicated support team available at any hour.
                                </p>
                            </div>

                            {/* Feature 2 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Mail className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Automated email sequences
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Engage your audience with personalized email campaigns that convert leads into loyal customers.
                                </p>
                            </div>

                            {/* Feature 3 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Calendar className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Smart content scheduling
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Plan and publish your social content in advance to maintain a consistent online presence.
                                </p>
                            </div>

                            {/* Feature 4 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Image className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Custom visual content
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Create stunning branded graphics and videos that capture attention and tell your story.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}